'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  viewport: 'dedicated',
  config: {
    id: '',
    textAlign: 'center',
    theme: 'theme-background-image-dark',
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business.jpg',
      portable: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-medium.jpg',
      mobile: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-small.jpg'
    },
    backgroundPosition: 'center',
    height: 'tall'
  },
  content: {
    headline: {
      text: '21 characters per line - 2 lines maximum.'
    },
    paragraph: {
      text: 'In mobile and tablet views, align text to optimize contrast with ' + 'background image. 152 characters maximum.'
    },
    mediaButton: {
      id: '',
      text: '25 characters maximum',
      'data-video-id': 'lkz4GZgyb9o'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    secondaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    actionDropdown: {
      content: {
        type: 'hyperlinks',
        items: [{
          text: 'Select a link (30 chars max)',
          key: 'no-selection',
          href: '#',
          target: '_self'
        }, {
          text: 'Link 1 (30 chars max)',
          key: 'online-sellers-solutions',
          href: 'https://www.paypal.com/uk/webapps/mpp/online-sellers-solutions',
          target: '_blank'
        }, {
          text: 'Link 2 (30 chars max)',
          key: 'in-person-sellers-solutions',
          href: 'https://www.paypal.com/uk/webapps/mpp/in-person-sellers-solutions',
          target: '_self'
        }]
      },
      callback: function callback() {},
      className: ''
    },
    hatchText: {
      text: '34 characters maximum per line'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/action-hero/props/default.js
// module id = 1069
// module chunks = 4